/**
 * localStorage can throw or be unavailable (private mode, strict browser / IT policy).
 * Axios interceptors must not throw or every API call fails while the server is still up.
 */
export function getLocalStorageItem(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function removeLocalStorageItem(key) {
  try {
    localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}
